import { graphql } from "api/cms-website/generated";

import { ResponsiveImageFragment } from "../primitives/responsiveImage";

export const TreatmentIncludesSectionFragment = graphql(/* GraphQL */ `
    fragment TreatmentIncludesSectionFragment on ComponentComponentsTreatmentIncludesSection {
        id
        noMarginBottom
        treatmentIncludesSectionTitle: title
        treatmentIncludesSectionImage: image {
            ...ResponsiveImageFragment
        }
        treatmentIncludesSectionItems: items {
            text
        }
    }
    ${ResponsiveImageFragment}
`);
